"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _CloseButton = require("./CloseButton");

var _atoms = require("../../atoms");

var _BackButton = require("./BackButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal, Drew Burnett
 */
var TitleSection = function TitleSection(_ref) {
  var className = _ref.className,
      open = _ref.open,
      onCloseClick = _ref.onCloseClick,
      hideCloseButton = _ref.hideCloseButton,
      onBackClick = _ref.onBackClick,
      children = _ref.children;
  var cname = "TitleSection";

  if (className) {
    cname += " " + className;
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: cname,
    trkAction: "Back Pressed"
  }, onBackClick && /*#__PURE__*/_react.default.createElement(_BackButton.BackButton, {
    onClick: onBackClick
  }), children, onCloseClick && !hideCloseButton && /*#__PURE__*/_react.default.createElement(_CloseButton.CloseButton, {
    onClick: onCloseClick
  }));
};

exports.TitleSection = TitleSection;